
import {map} from 'rxjs/operators';
import {Injectable, OnDestroy, OnInit} from "@angular/core";
import {RtlEnum} from "../interfaces/rtl.enum";
import {TranslateConfigService} from "../../translate/services/translate.config.service";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {Observable} from "rxjs";

const KendoRtlClass = 'k-rtl';

@UntilDestroy()
@Injectable()
export class RtlService implements OnInit, OnDestroy {
	_isRtl: boolean;

	constructor(private translateConfigService: TranslateConfigService) { }

	// eslint-disable-next-line @angular-eslint/contextual-lifecycle
	public ngOnInit() {
		this._isRtl = false;
	}

	public ngOnDestroy() { }

	/**
	 * Sets application direction
	 * @param {RtlEnum} dir
	 */
	public setDir(dir: RtlEnum): void {
		this._isRtl = dir === RtlEnum.rtl;
		__ris_global_vars__.rtl = this._isRtl;
		document.dir = RtlEnum[dir];

		let body = document.body;
		if (this._isRtl && !body.classList.contains(KendoRtlClass)) {
			body.classList.add(KendoRtlClass);
		} else if (!this._isRtl && body.classList.contains(KendoRtlClass)) {
			body.classList.remove(KendoRtlClass);
		}
	}

	/**
	 * Sets application direction according to the user default language key
	 * @param {number} key
	 */
	public setDirByLangKey(key: number): Observable<any> {
		return this.translateConfigService.getLanguages(true).pipe(untilDestroyed(this)).pipe(map(x => {
			let lang = x.find(l => l.languageKey === key);
			let dir = lang && lang.rightToLeft ? RtlEnum.rtl : RtlEnum.ltr;
			this.setDir(dir);

			return dir;
		}));
	}

	/**
	 * Checks if application is in rtl mode
	 * @returns {boolean}
	 */
	public isRtl(): boolean {
		return this._isRtl;
	}
}
